import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-plan-table-month__wrapper qa-plan-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelDateMonth = _resolveComponent("PanelDateMonth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.firstDayOfWeek && _ctx.calendarYear && _ctx.calendarMonth)
      ? (_openBlock(), _createBlock(_component_PanelDateMonth, {
          key: 0,
          events: _ctx.filteredEventByUsers,
          date: _ctx.date,
          firstDayOfWeek: _ctx.firstDayOfWeek,
          calendarYear: _ctx.calendarYear,
          calendarMonth: _ctx.calendarMonth,
          onOpenEvent: _ctx.openEventHandler
        }, null, 8, ["events", "date", "firstDayOfWeek", "calendarYear", "calendarMonth", "onOpenEvent"]))
      : _createCommentVNode("", true)
  ]))
}